var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthentication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.8748V6.37478M6.75 8.62481H11.25M15 8.99981C15 12.6811 10.9845 15.3586 9.5235 16.2109C9.35745 16.3078 9.27442 16.3563 9.15727 16.3814C9.0663 16.4009 8.9337 16.4009 8.84273 16.3814C8.72558 16.3563 8.64255 16.3078 8.4765 16.2109C7.01547 15.3586 3 12.6811 3 8.99981V5.41298C3 4.81335 3 4.51353 3.09807 4.25581C3.1847 4.02814 3.32548 3.82499 3.50824 3.66393C3.71513 3.48161 3.99585 3.37634 4.5573 3.1658L8.57865 1.65779C8.73457 1.59932 8.8125 1.57008 8.89275 1.55849C8.96385 1.54821 9.03615 1.54821 9.10725 1.55849C9.1875 1.57008 9.26543 1.59932 9.42135 1.65779L13.4427 3.1658C14.0041 3.37634 14.2849 3.48161 14.4917 3.66393C14.6745 3.82499 14.8153 4.02814 14.9019 4.25581C15 4.51353 15 4.81335 15 5.41298V8.99981Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthentication);
export default __webpack_public_path__ + "static/media/authentication.d91d60a781d7530d7afe16e8a7cb6d91.svg";
export { ForwardRef as ReactComponent };